<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <customAlertaModal
            :show-modal="showModal"
            :message="message"
            @update:showModal="showModal = $event"
            :show-back-button="btn_voltar_inModal"
          />
          <!-- <alertaSucesso
            :validacoes-sucesso="validacoes.sucesso"
            :message="validacoes.msg"
          /> -->
          <CAlert
          :show.sync="alertaCampoInvalido"
          :color = corAlerta
          >   
          {{textoAlerta }}         
          </CAlert>
          <CAlert
          :show.sync="alerta"
          :color = "colorAlert"
          >   
          {{ mensagem }}         
          </CAlert>
          <CCardBody>
            <CForm validated novalidate @submit="enviarFormulario($event)">
              <CTabs>
                <CTab>
                  <template slot="title">
                    <CIcon name="cil-bookmark" /> Dados de Cadastro
                  </template>
                  <br />

                  <CInput
                    v-model="paciente.name"
                    prepend="NOME"
                    required
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-badge" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="paciente.social_name"
                    prepend="NOME SOCIAL"
                    required
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-badge" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="paciente.cpf"
                    @change="verificaCpf"
                    prepend="CPF"
                    v-mask="cpf"
                    required
                  >
                    <template #append-content>
                      <CIcon name="cil-bank" />
                    </template>
                  </CInput>

                  <CInput
                    type="date"
                    v-model="paciente.data_nascimento"
                    prepend="D.NASCIMENTO"
                    required
                  >
                    <template #append-content>
                      <CIcon name="cil-bank" />
                    </template>
                  </CInput>

                  <CSelect
                    :options="profissionais"
                    :value.sync="paciente.profissional"
                    prepend="PROFISSIONAL"
                    invalid-feedback="* Campo obrigatório"
                  ></CSelect>

                  <CInput
                    v-model="paciente.email"
                    prepend="EMAIL"
                    autocomplete="email"
                    invalid-feedback="* Campo obrigatório"
                    @change="validarEmail()"
                  >
                    <template #append-content>
                      <CIcon name="cil-at" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="paciente.telefone"
                    prepend="TELEFONE"
                    invalid-feedback="* Campo obrigatório"
                    v-mask="telefone"
                  >
                    <template #append-content>
                      <CIcon name="cil-phone" />
                    </template>
                  </CInput>

                  <CSelect
                    :options="estados"
                    @change="listcities()"
                    v-model="paciente.uf"
                    :value.sync="paciente.uf"
                    prepend="UF"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>

                  <CSelect
                    :options="cidades"
                    v-model="paciente.city"
                    prepend="CIDADE"
                    autocomplete="Cidade"
                    placeholder="Selecione a Cidade"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>

                  <CInput
                    v-model="paciente.bairro"
                    prepend="BAIRRO"
                    autocomplete="bairro"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="paciente.cep"
                    prepend="CEP"
                    autocomplete="cep"
                    invalid-feedback="* Campo obrigatório"
                    v-mask="cep"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>

                  <CInput
                    v-model="paciente.end"
                    prepend="ENDEREÇO"
                    autocomplete="endereço"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>
                  <CInput
                    v-model="paciente.numero"
                    prepend="NÚMERO"
                    autocomplete="endereço"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CInput>

                  <CSelect
                    :options="listaDeConvenios"
                    v-model="paciente.insurance"
                    :value.sync="paciente.insurance"
                    prepend="CONVÊNIO"
                    placeholder="Selecione o Convênio"
                    invalid-feedback="* Campo obrigatório"
                  >
                    <template #append-content>
                      <CIcon name="cil-contact" />
                    </template>
                  </CSelect>

                  <CInput
                    v-model="paciente.numCart"
                    prepend="Nº CARTEIRINHA"
                    autocomplete="endereço"
                    invalid-feedback="* Campo obrigatório"
                  />
                  <template #append-content>
                    <CIcon name="cil-contact" />
                  </template>

                  <section class="radios-nf">
                    <div>PACIENTE NF:</div>
                    <div>
                      <input
                        type="radio"
                        id="um"
                        value="SIM"
                        v-model="paciente.nf"
                      />
                      <label for="um" class="radios-nf-check">SIM</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="dois"
                        value="NAO"
                        v-model="paciente.nf"
                      />
                      <label for="dois" class="radios-nf-check">NÃO</label>
                    </div>
                  </section>
                  <CButton type="submit" color="success" class="m-2"
                    >Cadastrar</CButton
                  >
                  <CButton color="info" class="m-2" @click="voltar()"
                    >Voltar</CButton
                  >
                </CTab>
              </CTabs>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import customAlertaModal from "../../../components/customAlertaModal.vue";
import alertaSucesso from "../../../components/alertaSucesso.vue";
import {
  buscarConvenios,
  buscarCpf,
  buscarEstados,
  buscarCidades,
  validarCamposPreenchidos,
  formularioPaciente,
  postPaciente,
} from "../../../common/pacientes/pacienteUtils";
import {
  converterMaiuscula,
  expressaoRegEmail,
} from "../../../utils/functionsUtils";

export default {
  name: "cadastrarPaciente",
  components: { customAlertaModal, alertaSucesso },
  data() {
    return {
      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      showModal: false,
      message: "",
      btn_voltar_inModal: false,
      cpf: "###.###.###-##",
      telefone: "(##) #####.####",
      cep: "#####-###",
      senha: false,
      convenios: [],
      validacoes: {
        sucesso: false,
        aviso: false,
        msg: "",
        ifs: false,
      },
      alertPessoa: false,
      items: [],
      listaDeConvenios: [],
      estados: [],
      cidades: [],
      paciente: {
        name: "",
        cpf: "",
        data_nascimento:null,
        end: "",
        email: "",
        profissional:"",
        city: "",
        insurance: "",
        numCart: "",
        telefone: "",
        uf: "RS",
        bairro: "",
        numero: "",
        cep: "",
        nf: "",
        social_name: "",
      },
      profissionais: [],
      alertaCampoInvalido: false,
      textoAlerta:"",
      corAlerta:"",
      alerta: false,
      mensagem: "",
      colorAlert:""
    };
  },

  // Funções utilizadas em methods se encontra, no arquivo pacienteUtils.js na pasta src/common

  // Functions que envolvem tratamento de dados podem ser encontradas no arquivo functionsUtils.js na pasta utils

  methods: {
    listarConvenios() {
      buscarConvenios().then((resposta) => {
        this.listaDeConvenios = resposta;
      });
    },
    verificaCpf() {
      let pacienteCpf = this.paciente.cpf;

      buscarCpf(pacienteCpf).then((resultado) => {
        if (resultado.showModal) {
          this.paciente.cpf = "";
          this.mostrarMensagemDeAlerta(resultado.msgModal);
        }
      });
    },
    listarTodosEstados() {
      buscarEstados().then((resultado) => {
        this.estados = resultado;
      });
    },
    listarTodasCidades() {
      const uf = this.paciente.uf;
      buscarCidades(uf).then((resposta) => {
        this.cidades = resposta;
      });
    },
    validarCampos() {
      if(this.paciente.profissional == ""){
        this.alertaCampoInvalido = true
        this.textoAlerta = "Profisisonal não foi selecionado"
        this.corAlerta = "warning"
        setTimeout(()=>{
          this.alertaCampoInvalido = false
        },4000)
        return
      }
      const resposta = validarCamposPreenchidos(this.paciente);

      if (resposta.validacoesAviso) {
        this.mostrarMensagemDeAlerta(resposta.validacoesMessage);
      } else {
        this.validacoes.ifs = true;
      }
    },
    validarEmail() {
      const regexEmail = expressaoRegEmail();
      if (!regexEmail.test(this.paciente.email)) {
        this.mostrarMensagemDeAlerta("Email inválido");
        this.paciente.email = "";
      }
    },
    enviarFormulario($event) {
       $event.preventDefault();
           this.validarCampos();

      const camposPreenchidos = this.validacoes.ifs;
      const resposta = formularioPaciente(camposPreenchidos);
      if (resposta.validacoesSucesso) {
        this.mostrarMensagemDeSucesso(resposta.validacoesSucesso);
        this.cadastrarPaciente();
      }
    },

    redirecionarListaDePacientes() {
      this.$router.push("/pacientes");
    },

    cadastrarPaciente() {
      
      let valoresConvertidos = {
        name: converterMaiuscula(this.paciente.name),
        bairro: converterMaiuscula(this.paciente.bairro),
        end: converterMaiuscula(this.paciente.end),
        city: converterMaiuscula(this.paciente.city),
      };
      const dadosPaciente = this.paciente;

      try {
        postPaciente(valoresConvertidos, dadosPaciente)
        .then((resposta) => {
          
          const { response } = resposta.res
          if(response?.status == 409){
            this.alerta = true
            this.mensagem = "CPF já cadastrado"
            this.colorAlert = "warning"
           
            setTimeout(()=>{
              this.alerta = false
            },3000)
            return
          }else{
            this.alerta = true
            this.mensagem = "Paciente Cadastrado"
            this.colorAlert = "success"

            setTimeout(()=>{
              this.alerta = false
            },3000)
          }
      });
      } catch (error) {
       
      }
    },
    mostrarMensagemDeSucesso(mensagem,id) {
      this.validacoes.sucesso = true;
      this.validacoes.msg = mensagem;
      
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        this.validacoes.sucesso = false;

        //  this.$router.push("/pacientes");
      }, 2000);
    },
    mostrarMensagemDeAlerta(mensagem) {
      this.showModal = true;
      this.message = mensagem;
      this.btn_voltar_inModal = true;
    },
    voltar() {
      this.$router.push("/pacientes");
    },
    listarProfissionais() {
      this.$http
        .get(process.env.VUE_APP_API_BASE_URL + "profissionais-lista")
        .then((res) => res.json())
        .then((payload) => {
          payload.forEach((elem) => {
            elem.name = elem.name
              .split(" ")
              .map(
                (nome) =>
                  nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
              )
              .join(" ");
          });
          payload.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.profissionais = payload.map((x) => {
            return {
              label: x.name,
              value: x.id,
            };
          });

          this.profissionais.unshift({
            label: "",
            value: null,
          })
        });
        
    },
    listcities(){
      this.cidades = []
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}cidades/${this.paciente.uf}`)
        .then((res) => res.json())
        .then((res) => {
          
          res.forEach((item)=>{
            this.cidades.push({
              label:item.name,
              value: item.name
            })
          })
        });
    }

  },

  mounted() {
    this.listarConvenios();
    this.listarTodosEstados();
    this.listarTodasCidades();
    this.listarProfissionais();
  },
};
</script>
<style scoped>
.input-group-prepend .input-group-text {
  width: 50px !important;
  text-align: center;
}
.radios-nf {
  color: #788393;
  display: grid;
  grid-template-columns: 100px 70px 1fr;
  height: 40px;
}
.radios-nf-check {
  margin-left: 10px;
}
</style>
